import { Breadcrumb, Col, Layout, message, Progress, Row } from "antd";
import { AuthActions } from "app/redux/actions";
import { LoadingSelectors } from "app/redux/reducers";
import { validateEmail } from "app/utils/string";
import AdvancedButton from "components/shared/AdvancedButton/AdvancedButton";
import AdvancedHeader from "components/shared/AdvancedHeader/AdvancedHeader";
import AdvancedInput from "components/shared/AdvancedInput/AdvancedInput";
import BackButton from "components/shared/BackButton/BackButton";
import React from "react";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { useNavigate } from "react-router-dom";

const { Content } = Layout;

class PasswordRecoveryWithRecaptcha extends React.PureComponent {
  state = {
    email: "",
    sendTo: 1,
  };

  onSubmit = async e => {
    e.preventDefault();

    let { email, sendTo } = this.state;
    const { sendRecoveryToken, googleReCaptchaProps } = this.props;

    if (email.length === 0 || email.length < 1) {
      return message.error(I18n.t("routes.passwordRecovery.errors.fields"));
    }

    if (!validateEmail(email)) {
      return message.error(I18n.t("errors.INVALID_EMAIL"));
    }

    let recaptchaToken =
      await googleReCaptchaProps.executeRecaptcha("passwordRecovery");
    await sendRecoveryToken({ email, sendTo, recaptchaToken }, () => {
      this.props.navigate(I18n.t("routes.passwordRecoveryCode.url"), {
        state: { email },
      });
      message.success(
        I18n.t("routes.passwordRecovery.messages.recoveryEmailSent")
      );
    });
  };

  render() {
    const { loading } = this.props;
    const { email } = this.state;

    return (
      <>
        <Layout className="advanced-layout">
          <AdvancedHeader />
          <Content className="advanced-layout__content">
            <Breadcrumb className="advanced-layout__content__bread ">
              <Breadcrumb.Item>
                {I18n.t("routes.passwordRecovery.parent")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {I18n.t("routes.passwordRecovery.pageTitle")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <form onSubmit={e => this.onSubmit(e)}>
              <h1 className="advanced-layout__content__title mt-4">
                {I18n.t("routes.passwordRecovery.content.title")}
              </h1>
              <p className="advanced-layout__content__subtitle">
                {I18n.t("routes.passwordRecovery.content.subtitle")}
              </p>
              <p className="advanced-layout__content__step">
                {I18n.t("routes.passwordRecovery.content.step")}
              </p>
              <Progress percent={33} status="active" showInfo={false} />
              <Row gutter={[10, 10]} className="mt-3">
                <Col xs={24} sm={24} md={16} lg={16}>
                  <AdvancedInput
                    disabled={loading && loading}
                    label="E-mail"
                    value={email}
                    onChange={value => this.setState({ email: value })}
                    tabIndex="1"
                  />
                </Col>
              </Row>
              <Row
                align="middle"
                justify="end"
                gutter={[10, 10]}
                className="mt-3"
              >
                <Col xs={24} sm={8} md={4} lg={4}>
                  <BackButton
                    text={I18n.t("components.backButton")}
                    onClick={() =>
                      this.props.navigate(I18n.t("routes.login.url"))
                    }
                  />
                </Col>
                <Col xs={24} sm={8} md={4} lg={4}>
                  <AdvancedButton
                    disabled={loading && loading}
                    text={I18n.t("components.nextButton")}
                    submit
                    isNext
                  />
                </Col>
              </Row>
            </form>
          </Content>
        </Layout>
      </>
    );
  }
}

const PasswordRecovery = withGoogleReCaptcha(PasswordRecoveryWithRecaptcha);

const mapStateToProps = state => ({
  loading: LoadingSelectors.getLoading(state),
});

const mapDispatchToProps = dispatch => ({
  sendRecoveryToken: (data, callback) =>
    dispatch(AuthActions.sendRecoveryToken(data, callback)),
});

const PasswordRecoveryWithNavigate = props => {
  const navigate = useNavigate();
  return <PasswordRecovery {...props} navigate={navigate} />;
};
PasswordRecoveryWithNavigate.displayName = "PasswordRecoveryWithNavigate";

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordRecoveryWithNavigate);
